module.exports = __webpack_public_path__ + "Keramo-ziznikov.jpg?b35e20b8875d8992917ee2c37b94642a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/Keramo-ziznikov.jpg
// module id = 245
// module chunks = 0